import React from 'react';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
import { ScarcityBar } from './ScarcityBar';
import { images } from '../data/content';
const items = ['Analysis.', 'Objectives.', 'Planning.', 'Preparation.', 'Case Review.'];
export function FinalCTA() {
  return <section className="bg-ink px-4 py-16 text-white" aria-labelledby="final-title" data-id="element-124" data-mp="84xkuh4g4316">
      <div className="mx-auto max-w-2xl text-center" data-id="element-125" data-mp="m4or1voq0f4m">
        <h2 id="final-title" className="font-serif text-[2rem] font-bold leading-tight sm:text-5xl" data-id="element-126" data-mp="m340si9fvick">
          Ready to stop starting every case from a <span className="italic text-gold" data-id="element-127" data-mp="vui28vkyas8c">blank page?</span>
        </h2>
        <p className="mt-4 text-lg text-white/75" data-id="element-128" data-mp="vwkrhdea4hc0">Start using a structured rhinoplasty case-planning system. Organize your:</p>
        <p className="mt-4 font-serif text-xl font-bold leading-relaxed text-gold-light" data-id="element-129" data-mp="14uwru74y6thn">{items.join(' ')}</p>
        <p className="mt-2 text-white/70" data-id="element-130" data-mp="zx4pskal9qzq">All inside one professional Blueprint.</p>

        <div className="mt-8 rounded-3xl bg-cream p-5 text-ink sm:p-8" data-id="element-131" data-mp="2c4wposz3okji">
          <img src={images.mockup} alt="" className="mx-auto w-full max-w-md" loading="lazy" data-id="element-132" data-mp="2c70ztsnlefs8" />
          <p className="mt-2 text-sm font-bold uppercase tracking-wider" data-id="element-133" data-mp="2h5u6b14gp6iw">Only</p>
          <p className="font-serif text-7xl font-bold leading-none" data-id="element-134" data-mp="2m1j695ke8pfq">$27</p>
          <p className="mt-3 text-sm text-muted" data-id="element-135" data-mp="2r2ypqt6xanw0">
            6 premium volumes · 5 exclusive bonuses · Instant digital access · Lifetime access · 7-day guarantee
          </p>
          <div className="mt-6" data-id="element-136" data-mp="3023o9zihih86">
            <ScarcityBar data-id="element-137" data-mp="30110i0ggkuwh" />
          </div>
          <div className="mt-6" data-id="element-138" data-mp="34tbzn13dkcnz">
            <CTAButton label="Get Sculptor’s Operating Blueprint™" data-id="element-139" data-mp="34t2blj1w4fkx" />
          </div>
          <div className="mt-8" data-id="element-140" data-mp="39sydncr11wxu">
            <Countdown data-id="element-141" data-mp="39r3tw1rhsavc" />
            <p className="mt-1 text-xs text-muted" data-id="element-142" data-mp="39uhsr00y61y1">The currency conversion is automatically adjusted according to your country.</p>
          </div>
        </div>
      </div>
    </section>;
}